// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import meetingMinutesEntity from './entities/meeting-minutes.json';
import meetingMinutesMenu from '../pages/meeting-minutes/menu.json';
import meetingMinutesFullForm from '../pages/meeting-minutes/forms/full.json';
import meetingMinutesContextForm from '../pages/meeting-minutes/forms/context.json';
import meetingMinutesMiniForm from '../pages/meeting-minutes/forms/mini.json';
import meetingMinutesLookupForm from '../pages/meeting-minutes/forms/lookup.json';
import meetingMinutesTableView from '../pages/meeting-minutes/views/table.json';
import meetingMinutesCardsView from '../pages/meeting-minutes/views/cards.json';
import meetingMinutesCalendarView from '../pages/meeting-minutes/views/calendar.json';
import meetingMinutesDashboardView from '../pages/meeting-minutes/views/dashboard.json';

/** Тип запису «Протокол засідання» зі сторінками пакета: меню, форми та подання з pages/meeting-minutes/. */
export const meetingMinutesDefinition: IRecordTypeDefinition = {
  ...meetingMinutesEntity,
  views: assembleViewSet({
      table: meetingMinutesTableView,
      cards: meetingMinutesCardsView,
      calendar: meetingMinutesCalendarView,
      dashboard: meetingMinutesDashboardView,
  }),
  form: meetingMinutesFullForm,
  forms: { full: meetingMinutesFullForm, context: meetingMinutesContextForm, mini: meetingMinutesMiniForm, lookup: meetingMinutesLookupForm },
  menu: meetingMinutesMenu,
} as IRecordTypeDefinition;
